import {CSAT_RANGE} from './csat-range.model';

/**
 * Ce que chaque étendue vaut en crans : le premier, et combien il y en a.
 *
 * `count` compte les crans et ne désigne pas le dernier : c'est ainsi que l'API lit le `range` d'une
 * satisfaction — onze crans de zéro à dix (cf. `ScaleNumberSettings`).
 */
export const CSAT_RANGE_BOUNDS: Record<CSAT_RANGE, {start: number; count: number}> = {
    [CSAT_RANGE.ONE_TO_FOUR]: {start: 1, count: 4},
    [CSAT_RANGE.ONE_TO_FIVE]: {start: 1, count: 5},
    [CSAT_RANGE.ZERO_TO_TEN]: {start: 0, count: 11},
};
